import { CLASS_NAMES, EVENTS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for handling the animation of the landing hero text wrapper
 */
export default class CampaignHero extends MessageBus {
  /**
   * Constructor function of the CampaignHero class.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    /**
     * DOM node that is passed into the constructor
     * @property {HTMLElement} element - The container element
     */
    this.element = element;

    this.init();
  }

  /**
   * Initializes the view by setting up the scroll event listener
   * @returns {CampaignHero} A reference to the current instance of the class
   * @chainable
   */
  init() {
    window.addEventListener(EVENTS.LOAD, () => {
      const heading = this.element.querySelector(
        `.${CLASS_NAMES.DARK_BG_CAMPAIGN_HERO_HEADLINE}`
      );
      const subheading = this.element.querySelector(
        `.${CLASS_NAMES.DARK_BG_CAMPAIGN_HERO_SUBHEADLINE}`
      );

      if (heading) {
        heading.classList.add(CLASS_NAMES.ANIMATE);
      }
      if (subheading) {
        subheading.classList.add(CLASS_NAMES.ANIMATE);
      }
    });

    return this;
  }
}
